import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InternationalActivitiesdetailComponent } from './international-activities-detail.component';
import { InternationalActivitiesdetailRoutingModule } from "./InternationalActivities-detail-routing";
import { TranslateModule } from "@ngx-translate/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
      CommonModule,
    InternationalActivitiesdetailRoutingModule,
      NgbModule,
    TranslateModule,
    FormsModule,   
    ReactiveFormsModule
    ],
  declarations: [InternationalActivitiesdetailComponent]
  })
export class InternationalActivitiesdetailModule { }
